export const PERIOD_SINCE = 'since';
export const PERIOD_TO = 'to';
export const DATE_FORMAT = 'yyyy-MM-dd';
export const DATETIME_FORMAT = 'yyyy-MM-DD HH:mm:ss';

export const ACCOUNT_MANAGEMENT_MODAL_COPY = {
  createTitle: 'Create account',
  editTitle: 'Manage account',
  managePlanTitle: 'Manage plan',
  createAction: 'Create account',
  editAction: 'Update account',
  managePlanAction: 'Change plan',
  manageAccountEntryLabel: 'Manage account',
  accountNameLabel: 'Account name',
  planLabel: 'Plan',
  addonsLabel: 'Add-ons',
  licensesLabel: 'Licenses',
  planLicensesLabel: 'Plan licenses',
  planOptionLabel: (planName: string, legacyLabel = '') =>
    `${planName}${legacyLabel ? ` ${legacyLabel}` : ''}`,
  planQuantityLabel: (planName: string) => `${planName} licenses`,
  increasePlanLicensesLabel: 'Increase plan licenses',
  decreasePlanLicensesLabel: 'Decrease plan licenses',
  addonQuantityLabel: (addonName: string, quantityLabel: string) =>
    `${addonName} ${quantityLabel.toLowerCase()}`,
  increaseAddonQuantityLabel: (addonName: string, quantityLabel: string) =>
    `Increase ${addonName} ${quantityLabel.toLowerCase()}`,
  decreaseAddonQuantityLabel: (addonName: string, quantityLabel: string) =>
    `Decrease ${addonName} ${quantityLabel.toLowerCase()}`,
  unlimitedLabel: 'Unlimited',
  vouchersLabel: 'Vouchers',
  advancedOptionsLabel: 'Advanced options',
  allLabel: 'ALL',
  selectedLabel: 'SELECTED',
  selectAllCertificationsLabel: 'Select all',
  selectCertificationLabel: (certificationCode: string) => `Select ${certificationCode}`,
  vouchersAccessLabel: 'Vouchers the account will have access to',
  planChangeDisclaimer: 'If you change the plan, some licenses might be affected.',
  confirmPlanChangesTitle: 'Are you sure you want to change the plan?',
  confirmPlanChangesDescription:
    'This might take a while. Changing plans may affect some licenses.',
  confirmPlanChangesAcceptLabel: 'Confirm',
  confirmPlanChangesCancelLabel: 'Cancel',
  startEndDateLabel: 'Start/End date',
  freeTrialLabel: 'Free trial',
  inviteOnlyLabel: 'Invite only',
  startDateLabel: 'STARTS:',
  endDateLabel: 'ENDS:',
  supportLabel: 'Support',
  salesLabel: 'Sales',
  representativePlaceholder: 'Select a representative',
  representativeFilterLabel: 'Filter representatives',
  legacyPlanLabel: 'LEGACY',
  closeLabel: 'Close modal',
  validationErrorTitle: 'Validation error',
  requiredFieldsError: 'Complete all required account fields before continuing.',
  addonCountError: 'Add-ons count cannot be greater than licenses count.',
  invalidQuantityError: 'Enter a whole number greater than or equal to 0.',
  certificationSelectionError:
    'At least one certification must be enabled when allocating vouchers.',
  createError: 'Couldn\u2019t create account',
  editError: 'Couldn\u2019t edit account',
  changePlanError: 'Couldn\u2019t change plan',
  loadAccountAddonDataError: 'Couldn\u2019t load account voucher data',
  noPlanChangesTitle: 'No changes detected',
  noPlanChangesDescription: 'No plan, voucher, or exam changes to save',
  noAccountChangesDescription: 'No account, plan, add-on, voucher, or exam changes to save',
  accountCreatedSuffix: 'account created.',
  accountUpdatedSuffix: 'account edited',
  accountReactivatedSuffix: 'account reactivated',
  goToAccountLabel: 'Go to account.',
  planUpdateFailureDescription: 'Please try again or contact support.',
  planOperationLabel: 'plan',
  voucherBalanceOperationLabel: 'voucher balance',
  enabledCertificationsOperationLabel: 'enabled exams',
  successfullyUpdatedLabel: 'Successfully updated',
  failedToUpdateLabel: 'Failed to update',
};
